var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.43 198.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_2065430731ed712ce3eba238c7dbfed6ecbaf02b2865389150471acba3392f76",
    x1: 39.53,
    y1: 43.62,
    x2: 159.61,
    y2: 43.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M81.22 87.44l18.11 12.42 17.92-12.42"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M150.04 49v80.53H48.71V49"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_0_2065430731ed712ce3eba238c7dbfed6ecbaf02b2865389150471acba3392f76)",
    d: "M40.78 38.87h117.59v9.5H40.78zM41.03 38.61l10.32-10.85h95.81l11.07 10.85M81.23 87.44h36.02v23.94H81.23zM61.62 68.04h74.75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInbox);
export default __webpack_public_path__ + "static/media/inbox.abe1a8e1a3baa055ffaf556932bb222f.svg";
export { ForwardRef as ReactComponent };